import {
	UserTypes,
	getMvcApplicationHeaders,
	getWebApiUrl,
	httpClient,
} from "@utils";
import { SSOGamesUserData } from "@api-types/user/SSOGamesUserData";
import { SSOGamesResponse } from "@api-types/user/SSOGamesResponse";

const requestHeaders = {
	"Content-Type": "application/json",
};
export default class UserApiService {
	private static get baseUrl(): string {
		return `${getWebApiUrl()}/api/games`;
	}
	static getRequestHeaders = (
		user: UserTypes = UserTypes.PRIMARY
	): HeadersInit => {
		const appHeaders = getMvcApplicationHeaders(user);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static getRedirectUrl(
		ssoGamesUserData: SSOGamesUserData
	): Promise<SSOGamesResponse> {
		const url = `${this.baseUrl}/url`;
		const authHeaders = this.getRequestHeaders();
		return httpClient.post(
			url,
			JSON.stringify(ssoGamesUserData),
			{ ...requestHeaders, ...authHeaders },
			{ responseType: "json" }
		);
	}
}
